import { render, staticRenderFns } from "./SignupCentre.vue?vue&type=template&id=5dd12e6c&scoped=true&"
import script from "./SignupCentre.vue?vue&type=script&lang=ts&"
export * from "./SignupCentre.vue?vue&type=script&lang=ts&"
import style0 from "./SignupCentre.vue?vue&type=style&index=0&id=5dd12e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd12e6c",
  null
  
)

export default component.exports